module.exports = __webpack_public_path__ + "static/media/install2.5677edc9.png";